module.exports = __webpack_public_path__ + "static/media/IconTemplates_-33.0be65319.svg";